import { DELIVERY_FEE, PICKUP_FEE } from './constants';

/**
 * Normalizes form values from both CartModal and OrderPanel structures
 * to a common format for validation.
 * 
 * CartModal format: { items: {...}, global: {...}, pickupAtOwnerLocation, returnAtOwnerLocation }
 * OrderPanel format: { otherOptionalFees: [...], [DELIVERY_FEE]: value, [PICKUP_FEE]: value, ... }
 * 
 * @param {Object} formValues - Form values from either CartModal or OrderPanel
 * @param {boolean} isCartModal - Whether the form values are from CartModal
 * @returns {Object} Normalized form values in OrderPanel format
 */
export function normaliseFormDeliveryPickupValues(formValues, isCartModal = false) {
    if (!isCartModal) {
        // OrderPanel format - already flat, return as-is
        return formValues;
    }

    // CartModal format - needs normalization
    const {
        items = {},
        global = {},
        pickupAtOwnerLocation = [],
        returnAtOwnerLocation = [],
    } = formValues || {};

    // Build normalized structure (OrderPanel format)
    const normalized = {
        pickupAtOwnerLocation,
        returnAtOwnerLocation,
        otherOptionalFees: [],
        [DELIVERY_FEE]: null,
        [PICKUP_FEE]: null,
        anyItemHasDelivery: false,
        anyItemHasPickup: false,
    };

    // Extract global delivery/pickup
    if (global.deliveryFee !== null && global.deliveryFee !== undefined) {
        normalized[DELIVERY_FEE] = global.deliveryFee;
    }
    if (global.optionalFees?.includes(DELIVERY_FEE)) {
        normalized.otherOptionalFees.push(DELIVERY_FEE);
    }

    if (global.pickupFee !== null && global.pickupFee !== undefined) {
        normalized[PICKUP_FEE] = global.pickupFee;
    }
    if (global.optionalFees?.includes(PICKUP_FEE)) {
        normalized.otherOptionalFees.push(PICKUP_FEE);
    }

    // If no global delivery/pickup values, check if any item has delivery/pickup selected
    if (normalized[DELIVERY_FEE] === null || normalized[PICKUP_FEE] === null || normalized.otherOptionalFees.includes(DELIVERY_FEE) || normalized.otherOptionalFees.includes(PICKUP_FEE)) {
        Object.values(items).forEach(itemValues => {
            if (itemValues.deliveryFee !== null && itemValues.deliveryFee !== undefined) {
                normalized.anyItemHasDelivery = true;
            }
            if (itemValues.pickupFee !== null && itemValues.pickupFee !== undefined) {
                normalized.anyItemHasPickup = true;
            }
            if (itemValues.optionalFees?.includes(DELIVERY_FEE)) {
                normalized.anyItemHasDelivery = true;
            }
            if (itemValues.optionalFees?.includes(PICKUP_FEE)) {
                normalized.anyItemHasPickup = true;
            }
            if(itemValues.requiredFees?.includes(DELIVERY_FEE)){
                normalized.anyItemHasDelivery = true;
            }
            if(itemValues.requiredFees?.includes(PICKUP_FEE)){
                normalized.anyItemHasPickup = true
            }
        });
    }
    return normalized;
}

export function normaliseDeliveryPickupConfig(deliveryPickupConfig) {
    const { globalDeliveryFee, globalPickupFee, isDeliveryRequired, isPickupRequired, hasDeliveryOption, hasPickupOption } = deliveryPickupConfig || {};
    return {
        deliveryFee: globalDeliveryFee,
        pickupFee: globalPickupFee,
        isDeliveryRequired,
        isPickupRequired,
        hasDeliveryOption,
        hasPickupOption,
    };
};